import { BellIcon } from "assets/icons/BellIcon";
import { InicioIcon } from "assets/icons/InicioIcon";
import { NewUserIcon } from "assets/icons/NewUserIcon";
import { NovedadesIcon } from "assets/icons/NovedadesIcon";
import { PRIVATE_ROUTE } from "../../../../routes/privateRoutes";
import { LISTA_COLORES_ICONOS } from "assets/icons/LISTA_COLORES_ICONOS";
import { PERMISOS } from "constants/permissions";
import { ReactNode } from "react";
import { Permisos } from "types/Permisos";
import { Orientaciones } from "../../../../screens/Orientaciones/Orientaciones";

interface renderIconProps {
  color: (typeof LISTA_COLORES_ICONOS)[keyof typeof LISTA_COLORES_ICONOS];
}

interface NavOption {
  renderIcon: (props: renderIconProps) => ReactNode;
  label: string;
  path: string;
  bottomHr: boolean;
  permissions: Permisos;
}

export const NAV_OPTIONS: { [key: string]: NavOption } = {
  INICIO: {
    renderIcon: ({ color }: renderIconProps) => <InicioIcon color={color} />,
    label: "Inicio",
    path: PRIVATE_ROUTE.INICIO,
    bottomHr: false,
    permissions: [],
  },
  NORMATIVAS: {
    renderIcon: ({ color }: renderIconProps) => <BellIcon color={color} />,
    label: "Normativas",
    path: PRIVATE_ROUTE.NORMATIVAS,
    bottomHr: false,
    permissions: [],
  },
  DISEÑOS_CURRICULARES: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Diseños curriculares",
    path: PRIVATE_ROUTE.DISEÑOS_CURRICULARES,
    bottomHr: false,
    permissions: [],
  },
  PLANES: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Planes",
    path: PRIVATE_ROUTE.PLANES,
    bottomHr: false,
    permissions: [],
  },
  PCI: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "PCI",
    path: PRIVATE_ROUTE.PCI,
    bottomHr: false,
    permissions: [],
  },
  CAJAS_CURRICULARES: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Cajas curriculares",
    path: PRIVATE_ROUTE.CAJAS_CURRICULARES,
    bottomHr: false,
    permissions: [],
  },
  TITULOS: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Títulos",
    path: PRIVATE_ROUTE.TITULOS,
    bottomHr: true,
    permissions: [],
  },
  // USUARIOS_PENDIENTES: {
  //     renderIcon: ({ color }: renderIconProps) => <NewUserIcon color={color} />,
  //     label: "Pendientes",
  //     path: PRIVATE_ROUTE.USUARIOS_PENDIENTES,
  //     bottomHr: false,
  //     permissions: []
  // },
  USUARIOS: {
    renderIcon: ({ color }: renderIconProps) => <NewUserIcon color={color} />,
    label: "Usuarios",
    path: PRIVATE_ROUTE.USUARIOS,
    bottomHr: true,
    permissions: [],
  },
  NIVELES: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Niveles",
    path: PRIVATE_ROUTE.NIVELES,
    bottomHr: false,
    permissions: [],
  },
  OPCION_PEDAGOGICA: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Opción Pedagógica",
    path: PRIVATE_ROUTE.OPCION_PEDAGOGICA,
    bottomHr: false,
    permissions: [],
  },
  MODALIDAD: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Modalidades",
    path: PRIVATE_ROUTE.MODALIDAD,
    bottomHr: false,
    permissions: [],
  },

  AREA: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Áreas",
    path: PRIVATE_ROUTE.AREA,
    bottomHr: false,
    permissions: [],
  },
  CICLO: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Ciclo",
    path: PRIVATE_ROUTE.CICLO,
    bottomHr: false,
    permissions: [],
  },

  COMBINATORIA: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Combinatoria",
    path: PRIVATE_ROUTE.COMBINATORIA,
    bottomHr: false,
    permissions: [],
  },

  ORIENTACIONES: {
    renderIcon: ({ color }: renderIconProps) => <NewUserIcon color={color} />,
    label: "Orientaciones",
    path: PRIVATE_ROUTE.ORIENTACIONES,
    bottomHr: false,
    permissions: [],
  },

  CERTIFICACIONES: {
    renderIcon: ({ color }: renderIconProps) => <NewUserIcon color={color} />,
    label: "Certificaciones",
    path: PRIVATE_ROUTE.CERTIFICACIONES,
    bottomHr: false,
    permissions: [],
  },

  TIPO_ESPACIO: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Tipo Espacio",
    path: PRIVATE_ROUTE.TIPO_ESPACIO,
    bottomHr: false,
    permissions: [],
  },

  ESPACIOS_CURRICULARES: {
    renderIcon: ({ color }: renderIconProps) => <NewUserIcon color={color} />,
    label: "Espacios Curriculares",
    path: PRIVATE_ROUTE.ESPACIOS_CURRICULARES,
    bottomHr: false,
    permissions: [],
  },

  ESPECIALIDADES: {
    renderIcon: ({ color }: renderIconProps) => <NewUserIcon color={color} />,
    label: "Especialidades",
    path: PRIVATE_ROUTE.ESPECIALIDAD,
    bottomHr: false,
    permissions: [],
  },

  VALIDEZ_NACIONAL: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Validez Nacional",
    path: PRIVATE_ROUTE.VALIDEZ_NACIONAL,
    bottomHr: false,
    permissions: [],
  },
  ORGANISMOS: {
    renderIcon: ({ color }: renderIconProps) => <NovedadesIcon color={color} />,
    label: "Organismos",
    path: PRIVATE_ROUTE.ORGANISMO,
    bottomHr: false,
    permissions: [],
  },
};
